module.exports = __webpack_public_path__ + "img/filter-selected-icon.e6556b99.svg";